// @ts-nocheck

import { HISTORY_ROUTE_ANCHOR_ID } from '../components/History';
import { SPORTS_ROUTE_ANCHOR_ID } from '../components/MobileSportsRouteView';
import { CATALOG_ROUTE_ANCHOR_ID } from '../components/RoutesCatalog';
import { HOME_ROUTE_ANCHOR_ID } from '../components/RoutesHome';
import { LIVE_ROUTE_ANCHOR_ID } from '../components/RoutesLive';
import { MATCH_ROUTE_ANCHOR_ID } from '../components/RoutesMatch';

import { isCatalog } from './routes/catalog';
import isHistory from './routes/isHistory';
import isHome from './routes/isHome';
import isLive from './routes/isLive';
import isMatch from './routes/isMatch';
import isSports from './routes/isSports';

export const getAnchorIdByPathname = (pathname) => {
  if (isHome(pathname)) {
    return HOME_ROUTE_ANCHOR_ID;
  }
  if (isSports(pathname)) {
    return SPORTS_ROUTE_ANCHOR_ID;
  }
  if (isLive(pathname)) {
    return LIVE_ROUTE_ANCHOR_ID;
  }
  if (isHistory(pathname)) {
    return HISTORY_ROUTE_ANCHOR_ID;
  }
  if (isCatalog(pathname)) {
    return CATALOG_ROUTE_ANCHOR_ID;
  }
  if (isMatch(pathname)) {
    return MATCH_ROUTE_ANCHOR_ID;
  }
};
